export default __webpack_public_path__ + "static/media/plain-sticker-H.a752c2f8.png";